import styled from 'styled-components'

export const Upload = styled.div`
  position: relative;

  & > * + * {
    margin-top: 10px;
  }
`

export const Preview = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 20px;
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-brand);
`

export const Image = styled.img`
  width: auto;
  height: auto;
  max-width: 400px;
  max-height: 400px;
  border: 20px solid #fff; // Fallback for browsers that don't support cqh units
  border: 1cqh solid #fff;
  box-shadow:
    0 0 12px 0 rgba(0, 0, 0, 0.15),
    0 1px 1px 0 rgba(0, 0, 0, 0.12);
`

export const RemoveButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
`

export const CropperContainer = styled.div`
  position: relative;
  aspect-ratio: 1800 / 1200;
  border: 1px solid var(--border-primary);
`
